
import {
  DestroyRef,
  Directive,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
  DOCUMENT
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  MatDrawer,
  MatDrawerContainer,
  MatSidenav,
  MatSidenavContainer,
} from '@angular/material/sidenav';

@Directive({
  selector: '[appDrawerAutosizeHack]',
})
export class DrawerAutosizeHackDirective implements OnInit, OnDestroy {
  private _doc = inject<Document>(DOCUMENT, { optional: true })!;
  private _el = inject<ElementRef<HTMLElement>>(ElementRef);

  private _drawer?: MatDrawer | MatSidenav =
    inject(MatDrawer, { optional: true, self: true, host: true }) ??
    inject(MatSidenav, { optional: true, self: true, host: true }) ??
    undefined;
  private _container?: MatDrawerContainer | MatSidenavContainer =
    inject(MatDrawerContainer, { optional: true }) ??
    inject(MatSidenavContainer, { optional: true }) ??
    undefined;
  private destroyRef = inject(DestroyRef);
  private resizeObserver?: ResizeObserver;

  ngOnInit(): void {
    this._drawer?.openedChange
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this._doc
          .querySelector('.mat-drawer-transition')
          ?.classList.remove('mat-drawer-transition');
      });

    this.resizeObserver = new ResizeObserver((entries) => {
      this._container?.updateContentMargins();
    });
    this.resizeObserver.observe(this._el.nativeElement);
  }

  ngOnDestroy(): void {
    this.resizeObserver?.unobserve(this._el.nativeElement);
  }
}
